import React from "react";
import { RestrictedRoute } from "../utils/RestrictedRoute";
import { Permissions } from "../utils/Permissions";
import { selectHasAnyDriveLicenceOutlet } from "../utils/identitySelectors";
import { Switch, Route } from "react-router";
import AssetTraitItem from "../components/Drive/AssetTraits/AssetTraitItem";
import AssetTraitsTable from "../components/Drive/AssetTraits/AssetTraitsTable";
import { NewAssetTraitRoute } from "../constants/routePaths";

export default function AssetTraitsRouting(props) {
  const { currentIdentity, resources } = props;
  return (
    <>
      <RestrictedRoute
        path="/assettraits"
        userPermissions={currentIdentity.permissions}
        routePermissions={[Permissions.AccessToDriveSettings]}
        accessAllowed={selectHasAnyDriveLicenceOutlet(currentIdentity)}
        resources={resources}
        render={(props) => {
          return (
            <AssetTraitsTable
              resources={resources}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
              refreshGrid={
                props &&
                props.location &&
                props.location.state &&
                props.location.state.refreshGrid
              }
            />
          );
        }}
      />

      <Switch>
        <Route
          exact
          path={NewAssetTraitRoute}
          render={() => (
            <AssetTraitItem
              resources={resources}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
            />
          )}
        />
        <Route
          exact
          path="/assettraits/:traitId"
          render={(props) => (
            <AssetTraitItem
              resources={resources}
              traitId={props.match.params.traitId}
              accessibleMoboOutlets={currentIdentity.accessibleMoboOutlets}
            />
          )}
        />
      </Switch>
    </>
  );
}
